import { GraphQLQuery } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { useCallback } from "react";
import { AgreementWithTransfer, GetAgreementFromForeignIdQuery, GetAgreementFromForeignIdQueryVariables } from "../API";
import { getAgreementFromForeignId as getAgreementFromForeignIdQuery } from "../graphql/queries";

export function useGetAgreementFromForeignId() {
    const agreementFromForeignId = useCallback(
        async ({ foreignId }: GetAgreementFromForeignIdQueryVariables): Promise<Partial<AgreementWithTransfer>> => {
            const result = await API.graphql<GraphQLQuery<GetAgreementFromForeignIdQuery>>({
                query: getAgreementFromForeignIdQuery,
                variables: { foreignId },
            });

            if (!result.data?.getAgreementFromForeignId) {
                return {};
            }

            return result.data?.getAgreementFromForeignId;
        },
        []
    );

    return { agreementFromForeignId };
}
